import styled from 'styled-components';
export const staticSize = {
    height: 161,
    width: 263,
};
export const ThumbnailContainer = styled.div.attrs(({ left, isVisible, backgroundImage, thumbnailPosition, scale = 1 }) => {
    const finalHeight = staticSize.height / scale;
    const finalWidth = staticSize.width / scale;
    const borderRadiosScaled = 8 / scale;
    return {
        style: {
            bottom: 21,
            left: `${left}px`,
            height: `${finalHeight}px`,
            width: `${finalWidth}px`,
            marginLeft: `-${finalWidth / 2}px`,
            display: `${isVisible && left ? 'flex' : 'none'}`,
            backgroundImage: `url("${backgroundImage}")`,
            backgroundPositionX: `-${thumbnailPosition.x}px`,
            backgroundPositionY: `-${thumbnailPosition.y}px`,
            transform: `scale(${scale})`,
            transformOrigin: 'bottom center',
            borderRadius: `${borderRadiosScaled}px`,
        },
    };
}) `
    position: absolute;
    flex-direction: row;
    justify-content: center;
    background: ${(props) => props.color};
`;
ThumbnailContainer.displayName = 'ThumbnailContainer';
//# sourceMappingURL=index.js.map